import { render, staticRenderFns } from "./HighlightsListView.vue?vue&type=template&id=766e5837&scoped=true&"
import script from "./HighlightsListView.vue?vue&type=script&lang=js&"
export * from "./HighlightsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e5837",
  null
  
)

export default component.exports